var _StageStreamCommand_platform, _StageStreamCommand_keyId;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Axios from 'axios';
export class StageStreamCommand {
    constructor(pf, keyId) {
        _StageStreamCommand_platform.set(this, void 0);
        _StageStreamCommand_keyId.set(this, void 0);
        __classPrivateFieldSet(this, _StageStreamCommand_platform, pf, "f");
        __classPrivateFieldSet(this, _StageStreamCommand_keyId, keyId, "f");
    }
    async execute() {
        const host = 'https://mycast.xyz:9011';
        const url = `${host}/stream/${__classPrivateFieldGet(this, _StageStreamCommand_platform, "f")}/${__classPrivateFieldGet(this, _StageStreamCommand_keyId, "f")}`;
        try {
            const { data } = await Axios.get(url);
            if (!data) {
                return null;
            }
            return data;
        }
        catch (e) {
            console.error('unknown error', e);
            return null;
        }
    }
}
_StageStreamCommand_platform = new WeakMap(), _StageStreamCommand_keyId = new WeakMap();
